import withRouter from './common/withRouter';

const NonAuthLayout = ({children}) => {
    return (
            children
    );
};

export default withRouter(NonAuthLayout);
